import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation, useParams } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import FocusAreas from "@/pages/FocusAreas";
import GetInvolved from "@/pages/GetInvolved";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfService from "@/pages/TermsOfService";
import Impact from "./pages/Impact";
import ClimaOneLanding from "./pages/Climaone-Landing-page";

import KnowledgeCentre from './pages/KnowledgeCentre';
import BlogPost from './pages/BlogPost';

import AdminLogin from './pages/AdminLogin';
import AdminLayout from './pages/AdminLayout';
import AdminBlogs from './pages/AdminBlogs';
import AdminBlogEditor from './pages/AdminBlogEditor';
import AdminUsers from './pages/AdminUsers';

import { initializeGoogleAnalytics, trackPageView } from './utils/analytics';


const CLIMAONE_HOSTS = new Set(["climaonev2.recircle.in", "www.climaonev2.recircle.in"]);

// Component to track page views
function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
}

function BlogSlugRedirect() {
  const { slug } = useParams();
  return <Navigate to={`/blog/${slug}`} replace />;
}

function App() {
  // Initialize Google Analytics on app start
  useEffect(() => {
    initializeGoogleAnalytics();
  }, []);
  const hostname =
    typeof window !== "undefined" ? window.location.hostname.toLowerCase() : "";
  const isClimaOneHost = CLIMAONE_HOSTS.has(hostname);

  if (isClimaOneHost) {
    return (
      <div className="App">
        <ClimaOneLanding />
        <Toaster position="top-right" />
      </div>
    );
  }

  return (
    <div className="App">
      <BrowserRouter>
        <AnalyticsTracker />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/focus-areas" element={<FocusAreas />} />
            <Route path="/impact" element={<Impact />} />
            <Route path="/get-involved" element={<GetInvolved />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/climaone" element={<ClimaOneLanding />} />
            <Route path="/blog" element={<KnowledgeCentre />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/knowledge-centre" element={<Navigate to="/blog" replace />} />
            <Route path="/blogs" element={<Navigate to="/blog" replace />} />
            <Route path="/blogs/:slug" element={<BlogSlugRedirect />} />

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Navigate to="blogs" replace />} />
              <Route path="blogs" element={<AdminBlogs />} />
              <Route path="blogs/new" element={<AdminBlogEditor />} />
              <Route path="blogs/:id" element={<AdminBlogEditor />} />
              <Route path="users" element={<AdminUsers />} />
            </Route>
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
